<!--
  @project E-School Web
  @author Vothana CHY
  @date 2026-06-30
-->

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
